import "./FooterCopyright.css"
export default function FooterCopyright() {
    return (
        <div className="footer-bottom">
            Copyright ©2025 . All Rights Reserved
        </div>
    );
}
